<template>
  <BaseFieldset title="App-gebruikers">
    <form @submit.prevent="uploadFile">
      <material-alert v-show="appResults" color="success">
        <div v-for="(value, name) in appResults" :key="`${name}_${value}`">
          {{ name }}: {{ value || 0 }}
        </div>
      </material-alert>

      <material-alert v-show="appUploading" color="info">
        Uploading {spinner gif :P}
      </material-alert>

      <material-alert v-show="appError.length" color="danger">
        {{ appError }}
      </material-alert>

      <label for="importUsersFile"> File for importing only users </label>

      <material-input
        id="importUsersFile"
        :disabled="appUploading"
        type="file"
        name="importUsersFile"
        @change="handleFileUpload($event, 'users')"
      />
      <br />

      <label for="importCompaniesAndUsersFile">
        File for importing companies and users
      </label>

      <material-input
        id="importCompaniesAndUsersFile"
        :disabled="appUploading"
        type="file"
        name="importCompaniesUsersFile"
        @change="handleFileUpload($event, 'companies-users')"
      />

      <material-button
        class="float-end mt-6 mb-0"
        color="dark"
        variant="gradient"
        size="sm"
      >
        upload
      </material-button>
    </form>
  </BaseFieldset>
  <BaseFieldset title="Clubs">
    <form @submit.prevent="uploadFile">
      <material-alert v-show="clubsResults" color="success">
        <div v-for="(value, name) in clubsResults" :key="`${name}_${value}`">
          {{ name }}: {{ value || 0 }}
        </div>
      </material-alert>

      <material-alert v-show="clubsUploading" color="info">
        Uploading {spinner gif :P}
      </material-alert>

      <material-alert v-show="clubsError.length" color="danger">
        {{ clubsError }}
      </material-alert>

      <label for="sportTypeDropdown">Sport type</label>
      <br />

       <small v-if="!sportTypes.length" class="text-danger">
        No sport types available
        <br />
      </small>

      <material-select
        id="sportTypeDropdown"
        v-model="selectedSportTypeId"
        :options="sportTypes"
        :disabled="!sportTypes.length || clubsUploading"
        label="Sport type"
        label-key="sportName"
        value-key="id"
      />
      <br />

      <label for="importClubsFile"> File for importing clubs </label>

      <material-input
        id="importClubsFile"
        :disabled="clubsUploading"
        type="file"
        name="importClubsFile"
        @change="handleFileUpload($event, 'clubs')"
      />
      <br />

      <material-button
        class="float-end mt-6 mb-0"
        color="dark"
        variant="gradient"
        size="sm"
      >
        upload
      </material-button>
    </form>
  </BaseFieldset>
</template>

<script>
import store from "@/store";
import BaseFieldset from "@/components/Forms/BaseFieldset.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialSelect from "../../components/MaterialSelect.vue";

export default {
  name: "Dashboard",

  components: {
    BaseFieldset,
    MaterialAlert,
    MaterialButton,
    MaterialInput,
    MaterialSelect,
  },

  data: () => ({
    // App-gebruikers form
    appUploading: false,
    appError: "",
    appResults: undefined,

    // Clubs form
    clubsUploading: false,
    clubsError: "",
    clubsResults: undefined,
    sportTypes: [],
    selectedSportTypeId: null,

    // Shared
    importFile: "",
    importType: "",
  }),

  mounted() {
    fetch(`${process.env.VUE_APP_API_BASE_URL}/sporttype`, {
      headers: {
        Authorization: `Bearer ${store.getters["account/bearerToken"]}`,
        "X-Organization-Code": store.getters["account/organizationCode"],
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.sportTypes = data;
        if (data.length) this.selectedSportTypeId = data[0].id;
      })
      .catch(() => {
        this.sportTypes = [];
      });
  },

  methods: {
    handleFileUpload(e, type) {
      this.importFile = e.target.files[0];
      this.importType = type;
    },

    uploadFile() {
      const isClubs = this.importType === "clubs";

      if (isClubs && !this.selectedSportTypeId) {
        this.clubsError = "Please select a sport type";
        return;
      }

      const formData = new FormData();
      formData.append("file", this.importFile);

      const url = isClubs
        ? `${process.env.VUE_APP_API_BASE_URL}/dashboard/import/clubs/${this.selectedSportTypeId}`
        : `${process.env.VUE_APP_API_BASE_URL}/dashboard/import/${this.importType}`;

      // Reset states
      if (isClubs) {
        this.clubsUploading = true;
        this.clubsError = "";
        this.clubsResults = undefined;
      } else {
        this.appUploading = true;
        this.appError = "";
        this.appResults = undefined;
      }

      fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${store.getters["account/bearerToken"]}`,
          "X-Organization-Code": store.getters["account/organizationCode"],
        },
        body: formData,
      })
        .then(async (response) => {
          const json = await response.json();

          if (response.ok) {
            isClubs ? (this.clubsResults = json) : (this.appResults = json);
          } else {
            isClubs
              ? (this.clubsError = json.message || "Something went wrong.")
              : (this.appError = json.message || "Something went wrong.");
          }
        })
        .catch(() => {
          isClubs
            ? (this.clubsError = "Network error.")
            : (this.appError = "Network error.");
        })
        .finally(() => {
          isClubs ? (this.clubsUploading = false) : (this.appUploading = false);
        });
    },
  },
};
</script>
